module.exports = __webpack_public_path__ + "img/rank-header.562c89a5.png";